import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import CategoriesTag from './CategoriesTag.component';

/** @namespace Pwa/Component/CategoriesTag/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    device: state.ConfigReducer.device,
});

/** @namespace Pwa/Component/CategoriesTag/Container/mapDispatchToProps */
export const mapDispatchToProps = (_dispatch) => ({});

/** @namespace Pwa/Component/CategoriesTag/Container */
export class CategoriesTagContainer extends PureComponent {
    static propTypes = {
        items: PropTypes.array.isRequired,
    };

    state = {
        isContentExpanded: false,
    };

    containerFunctions = {
        toggleExpand: this.toggleExpand.bind(this),
    };

    toggleExpand() {
        const { isContentExpanded } = this.state;
        const elementContainer = document.getElementsByClassName('CategoriesTag');
        if (!elementContainer) return null;

        this.setState(({ isContentExpanded }) => ({ isContentExpanded: !isContentExpanded }));

        const y =
            elementContainer[0].getBoundingClientRect().top + window.pageYOffset + (isContentExpanded ? -600 : -150);

        window.scrollTo({ top: y, behavior: 'smooth' });
    }

    containerProps() {
        return {
            ...this.props,
            ...this.state,
        };
    }

    render() {
        return <CategoriesTag {...this.containerFunctions} {...this.containerProps()} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesTagContainer);
